<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.processFlowId" hidden/>


      <t-form-tab title="Dados Básicos">

        <t-form-card title="Denominação" icon-info-square>

          <t-input v-model="form.name"  :add-error="error.name" label="Nome" required/>

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status"/>

        </t-form-card>

        <t-form-card title="Grupos de produtos" icon-folder>

          <b-form-checkbox class="col-sm-12 ml-2" v-model="form.availableAllGroups" switch>
            Disponibilizar este Fluxo-Processo a todos os grupos de produtos?
            <t-help
                title="Você poderá especificar quais os grupos podem utilizar, basta desmarcar esta opção e selecionar os grupos de produtos desejados."/>
          </b-form-checkbox>

          <div v-show="!form.availableAllGroups" class="mt-2">
            <div v-for="family in groupProductOptions" :key="family.groupId" class="pb-2 mb-2 border-bottom">

              <h6 class="mb-0"><b>{{ family.groupLabel }}</b></h6>

              <b-form-checkbox class="ml-3" v-for="item in family.options" :key="item.value"
                               :checked="form.groupsProduct.find(a => a.groupProductId === item.value) != null"
                               @change="addSelected($event,item.value,'groupProductId',form.groupsProduct)">
                {{ item.text }}
              </b-form-checkbox>

            </div>

          </div>

        </t-form-card>

        <t-form-card title="Modelos" icon-folder>

          <b-form-checkbox class="col-sm-12 ml-2" v-model="form.availableAllModels" switch>
            Disponibilizar este Fluxo-Processo a todos os modelos?
            <t-help
                title="Você poderá especificar quais os modelos, basta desmarcar esta opção e selecionar os modelos desejadas."/>
          </b-form-checkbox>

          <div v-if="!form.availableAllModels" class="mt-2">

            <b-form-checkbox class="ml-3" v-for="item in modelOptions" :key="item.value"
                             :checked="form.models.find(a => a.modelId === item.value) != null"
                             @change="addSelected($event,item.value,'modelId',form.models)">
              {{ item.text }}
            </b-form-checkbox>

          </div>

        </t-form-card>

        <t-form-card title="Materiais" icon-folder>

          <b-form-checkbox class="col-sm-12 ml-2" v-model="form.availableAllMaterials" switch>
            Disponibilizar este Fluxo-Processo a todos os materiais?
            <t-help
                title="Você poderá especificar quais os materiais, basta desmarcar esta opção e selecionar os materiais desejados."/>
          </b-form-checkbox>

          <div v-if="!form.availableAllMaterials" class="mt-2">

            <b-form-checkbox class="ml-3" v-for="item in materialsOptions" :key="item.value"
                             :checked="form.materials.find(a => a.materialId === item.value) != null"
                             @change="addSelected($event,item.value,'materialId',form.materials)">
              {{ item.text }}
            </b-form-checkbox>

          </div>

        </t-form-card>

        <t-form-card title="Embalagens" icon-folder>

          <b-form-checkbox class="col-sm-12 ml-2" v-model="form.availableAllUnits" switch>
            Disponibilizar este Fluxo-Processo a todas as embalagens?
            <t-help
                title="Você poderá especificar quais as emabalgens, basta desmarcar esta opção e selecionar as embalagens desejadas."/>
          </b-form-checkbox>

          <div v-if="!form.availableAllUnits" class="mt-2">

            <b-form-checkbox class="ml-3" v-for="item in unitOptions" :key="item.value"
                             :checked="form.units.find(a => a.unitId === item.value) != null"
                             @change="addSelected($event,item.value,'unitId',form.units)">
              {{ item.text }}
            </b-form-checkbox>

          </div>


        </t-form-card>

      </t-form-tab>

      <template #out-of-form>

        <t-form-tab title="Etapas do Processo" hash="step" lazy>

          <t-msg v-if="isUpdate()" info>Atualizações no fluxo de etapas serão aplicadas somente a novas Ordens de
            Fabricação ou para Ordens em Andamento que desejar aplicar a ação 'Atualizar Fluxo de Processo'.
          </t-msg>

          <ProcessFlowStep :foreign-key="form.processFlowId"/>

        </t-form-tab>


        <t-form-tab title="Etiquetas" hash="label" lazy>

          <t-form-card title="Regras de Impressão">

            <t-msg info>
              Utilize esta seção para definir condições especiais que deverão ser atendidas antes da liberação da primeira impressão de determinadas etiquetas neste fluxo de processo.
            </t-msg>

            <ProcessFlowLabelPrintRestriction
                :foreign-key="form.processFlowId"/>

          </t-form-card>

        </t-form-tab>


      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ProcessFlowStep from "@/views/modules/production/ProcessFlow/ProcessFlowStep";
import ProcessFlowLabelPrintRestriction
  from "@/views/modules/production/ProcessFlow/ProcessFlowLabelPrintRestriction.vue";
import groupProductService from "@/services/modules/product/GroupProduct.service";
import ui from "@/assets/scripts/ui";
import unitService from "@/services/modules/product/Unit.service";
import modelService from "@/services/modules/product/Model.service";
import materialService from "@/services/modules/product/Material.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ProcessFlowForm',
  components: {ProcessFlowStep, ProcessFlowLabelPrintRestriction},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "processFlowId",
      form: {
        processFlowId: 0,
        name: "",
        note: "",
        availableAllGroups: true,
        availableAllModels: true,
        availableAllMaterials: true,
        availableAllUnits: true,
        groupsProduct: [],
        models: [],
        materials:[],
        units: [],
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      unitOptions: [],
      modelOptions: [],
      materialsOptions: [],
      groupProductOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await unitService.selectList().then((response) => {
        this.unitOptions = response
      }).catch(error => this.responseError(error))

      await modelService.selectList().then((list) => {
        this.modelOptions = list
      }).catch(error => this.responseError(error))

      await materialService.selectList().then((list) => {
        this.materialsOptions = list
      }).catch(error => this.responseError(error))

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list

        //Injeta campo checked
        for (let group of this.groupProductOptions) {
          for (let item of group.options) {
            item.checked = false
          }
        }

      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true


    },
    async onSubmit() {

      if (!this.form.availableAllGroups && this.form.groupsProduct.length === 0) {
        ui.msgError(this, "Você marcou a opção de especificar grupos para este Fluxo-Processo, porém não selecionou nenhum grupo. Desmarque a opção ou selecione pelo menos um grupo antes de continuar.")
      } else {

        if (!this.form.availableAllGroups && this.form.groupsProduct.length === 0) {
          ui.msgError(this, "Você marcou a opção de especificar emabalagens para este Fluxo-Processo, porém não selecionou nenhuma embalagem. Desmarque a opção ou selecione pelo menos uma embalgem antes de continuar.")
        } else {
          await this.setSendingDefault()
        }

      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    addSelected(checked, id, primaryKey, array){

      if (checked) {
        //Adicionar
        const el = array.find(a => a[primaryKey] === id)
        if (el == null)
          array.push({[primaryKey]: id})
      } else {
        //Remover
        const indexRemove = array.findIndex(a => a[primaryKey] === id)

        if (indexRemove >= 0)
          array.splice(indexRemove, 1)

      }

    },



    selectGroup(checked, array) {

      for (const el of array) {
        this.addGroupSelected(checked, el.value)
      }

    },


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
